var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.isPhrasingContent ? 'span' : 'h2',{tag:"component",class:[
    _setup.fontClass,
    'text-body-small',
    'break-word-anywhere',
    'whitespace-break-spaces',
    {
      'text-dark-text-200': _vm.colorScheme === 'light',
      'text-light-text-200': _vm.colorScheme === 'dark',
    },
  ],attrs:{"data-testid":"surfaceDescription"},domProps:{"innerHTML":_vm._s(_setup.hyperlinkedText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }